import React from 'react'
import rowConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Row/configAggregator'
import Row from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Row'
import columnConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Column/configAggregator'
import Column from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Column'
import columnGroupConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/ColumnGroup/configAggregator'
import ColumnGroup from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/ColumnGroup'
import imageConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Image/configAggregator'
import Image from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Image'
import headingConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Heading/configAggregator'
import Heading from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Heading'
import textConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Text/configAggregator'
import Text from '@components/alfakher/pylot-rich-content/src/PageBuilder/ContentTypes/Text'
import tabsConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Tabs/configAggregator'
import tabItemConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/TabItem/configAggregator'
import blockConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Block/configAggregator'
import productsConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Products/configAggregator'
import buttonsConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Buttons/configAggregator'
import buttonItemConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/ButtonItem/configAggregator'
import htmlConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Html/configAggregator'
import dividerConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Divider/configAggregator'
import videoConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Video/configAggregator'
import mapConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Map/configAggregator'
import bannerConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Banner/configAggregator'
import ButtonItem from '@components/alfakher/pylot-rich-content/src/PageBuilder/ContentTypes/ButtonItem/buttonItem'
import sliderConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Slider/configAggregator'
import richSliderConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/RichSlider/configAggregator'
import multiSliderConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/SliderMultiCarousel/configAggregator'
import verticalSliderConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/VerticalSlider/configAggregator'
import vimeoVideoConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/VimeoVideo/configAggregator'
import columnWrapperConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/ColumnWithWrapper/configAggregator'
import learnMoreColumnConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/LearnMoreColumn/configAggregator'
import JPHomeRichSliderConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/JPHomeRichSlider/configAggregator'
import columnLineConfigAggregator from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/ColumnLine/configAggregator'
import ColumnLine from '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/ColumnLine'
import dynamic from 'next/dynamic'
import { getAllCustomWidgets } from '@corratech/pylot-custom-widgets/getAllCustomWidgets'

/* istanbul ignore next */
const contentTypesConfig = {
    row: {
        configAggregator: rowConfigAggregator,
        component: Row
    },
    column: {
        configAggregator: columnConfigAggregator,
        component: Column
    },
    'column-group': {
        configAggregator: columnGroupConfigAggregator,
        component: ColumnGroup
    },
    'column-line': {
        configAggregator: columnLineConfigAggregator,
        component: ColumnLine
    },
    image: {
        configAggregator: imageConfigAggregator,
        component: Image
    },
    heading: {
        configAggregator: headingConfigAggregator,
        component: Heading
    },
    text: {
        configAggregator: textConfigAggregator,
        component: Text
    },
    tabs: {
        configAggregator: tabsConfigAggregator,
        component: dynamic(() =>
            import(
                '@components/alfakher/pylot-rich-content/src/PageBuilder/ContentTypes/Tabs/SelectTabs'
            )
        )
    },
    'tab-item': {
        configAggregator: tabItemConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/TabItem'
            )
        )
    },
    buttons: {
        configAggregator: buttonsConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Buttons'
            )
        )
    },
    'button-item': {
        configAggregator: buttonItemConfigAggregator,
        component: ButtonItem
    },
    block: {
        configAggregator: blockConfigAggregator,
        component: dynamic(() => import('./ContentTypes/Block'))
    },
    products: {
        configAggregator: productsConfigAggregator,
        component: dynamic(() => import('./ContentTypes/Products'))
    },
    html: {
        configAggregator: htmlConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Html'
            )
        )
    },
    divider: {
        configAggregator: dividerConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Divider'
            )
        )
    },
    video: {
        configAggregator: videoConfigAggregator,
        component: dynamic(() =>
            import(
                '@components/alfakher/pylot-rich-content/src/PageBuilder/ContentTypes/Video'
            )
        )
    },
    map: {
        configAggregator: mapConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/Map'
            )
        )
    },
    banner: {
        configAggregator: bannerConfigAggregator,
        component: dynamic(() => import('./ContentTypes/Banner'))
    },
    slider: {
        configAggregator: sliderConfigAggregator,
        component: dynamic(() => import('./ContentTypes/Slider'))
    },
    // Slide is just a banner wrapped inside a slider
    slide: {
        configAggregator: bannerConfigAggregator,
        component: dynamic(() => import('./ContentTypes/Banner'))
    },
    // #CORRA Slide converted out of content type tabs
    'rich-slider': {
        configAggregator: richSliderConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/RichSlider'
            )
        )
    },
    // #CORRA Slide converted out of content type tabs for JP Home
    'jp-home-rich-slider': {
        configAggregator: JPHomeRichSliderConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/JPHomeRichSlider'
            )
        )
    },
    // #CORRA Multi Slide converted out of content type tabs
    'slider-multi': {
        configAggregator: multiSliderConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/SliderMultiCarousel'
            )
        )
    },
    'vertical-slider': {
        configAggregator: verticalSliderConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/VerticalSlider'
            )
        )
    },
    'vimeo-video': {
        configAggregator: vimeoVideoConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/VimeoVideo'
            )
        )
    },
    'wrapper-column': {
        configAggregator: columnWrapperConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/ColumnWithWrapper'
            )
        )
    },
    'learn-more-column': {
        configAggregator: learnMoreColumnConfigAggregator,
        component: dynamic(() =>
            import(
                '@corratech/pylot-rich-content/src/PageBuilder/ContentTypes/LearnMoreColumn'
            )
        )
    },
    ...getAllCustomWidgets
}

/**
 * Retrieve a content types configuration
 *
 * @param {string} contentType
 * @param extendedContentTypeConfig
 * @returns {*}
 */
export default function getContentTypeConfig(
    contentType,
    extendedContentTypeConfig = {}
) {
    const mergedContentTypesConfig = {
        ...contentTypesConfig,
        ...extendedContentTypeConfig
    }
    if (mergedContentTypesConfig[contentType]) {
        return mergedContentTypesConfig[contentType]
    }
}

/**
 * Set content types configuration with new one
 *
 * @param {string} contentType
 * @param {*} config
 * @returns {*}
 */
export function setContentTypeConfig(contentType, config) {
    return (contentTypesConfig[contentType] = config) // NOSONAR
}
